import { render } from "./stronaPodgladuWiadomosc.vue?vue&type=template&id=0e033bb5&scoped=true"
import script from "./stronaPodgladuWiadomosc.vue?vue&type=script&lang=js"
export * from "./stronaPodgladuWiadomosc.vue?vue&type=script&lang=js"

import "./stronaPodgladuWiadomosc.vue?vue&type=style&index=0&id=0e033bb5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e033bb5"]])

export default __exports__